import React from 'react';
import screen3d from '../../img/screen3d.png';
import './intro.css';
import { FaGithub, FaLinkedin, FaTwitter, FaInstagram } from "react-icons/fa";
import { IoMdMailOpen } from 'react-icons/io';

const Intro = () => {
    return(
        <div className="container">
            <section className="left">
                <div className="info">
                    <text className="heading">Hello! <text className="heading name">I am</text></text>
                    <p className="heading name">Sachin Karun</p>
                    <div className="tag_box">
                        <p className="tag">FULL STACK WEB DEVELOPER</p>
                    </div>

                    <p className="desc">A motivated and flexible Computer Science Engineer with a combine ability
                    of designing and developing skill, knowledge of user interface and responsive designs, and always
                    ready to work on new projects and have new experiences.
                    </p>

                    <a href="#Contacts">
                        <button className="btn">Contact</button>
                    </a>

                    <div className="icons">
                        <a href="https://www.instagram.com/sachin_karun" target="_blank" rel="noreferrer">
                            <FaInstagram className="icon"/>
                        </a>
                        <a href="https://github.com/sachinkarun" target="_blank" rel="noreferrer">
                            <FaGithub className="icon"/>
                        </a>
                        <a href={"mailto: sachinkarun02@gmail.com"} target="_blank" rel="noreferrer">
                            <IoMdMailOpen className="icon"/>
                        </a>
                        <a href="https://www.linkedin.com/in/sachin-karun" target="_blank" rel="noreferrer">
                            <FaLinkedin className="icon"/>
                        </a>
                        <a href="https://twitter.com/SachinKarun" target="_blank" rel="noreferrer">
                            <FaTwitter className="icon"/>
                        </a>
                    </div>
                </div>
            </section>

            <section className="right">
                <img src={screen3d} alt="image" className="image3d" />
            </section>
        </div>
    )
}

export default Intro